export default __webpack_public_path__ + "static/media/learose2-1440w.73097159.webp";